// =============================================================================
//  liveMode.ts - flag global pour basculer entre demo (mocks localStorage) et
//  live (vraie API NIS365). Decide a partir de VITE_API_BASE_URL :
//   - undefined / vide -> mode demo
//   - URL valide       -> mode live
//
//  Pour basculer en local dev :
//   1. cp .env.example .env.local
//   2. Set VITE_API_BASE_URL=http://localhost:7071/api
//   3. npm run dev
// =============================================================================

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

// ---------------------------------------------------------------------------
// MODE DÉMO : override runtime (flag localStorage), togglé depuis /devmode.
// Quand actif, IS_LIVE_MODE bascule à false -> toute l'app utilise les mocks
// (tenant Business Contoso, scans M365 générés), et les wrappers d'API Azure /
// CyFun / onboarding / licence renvoient les données de src/demo/demoData.ts.
// ---------------------------------------------------------------------------
export const DEMO_MODE_KEY = 'nis365.demoMode';

export function isDemoMode(): boolean {
  try { return localStorage.getItem(DEMO_MODE_KEY) === '1'; } catch { return false; }
}

export function setDemoMode(on: boolean): void {
  try {
    if (on) localStorage.setItem(DEMO_MODE_KEY, '1');
    else localStorage.removeItem(DEMO_MODE_KEY);
  } catch { /* ignore */ }
}

/** Évalué à l'import (donc figé jusqu'au prochain reload — voulu). */
export const DEMO_MODE = isDemoMode();

export const IS_LIVE_MODE = API_BASE_URL.length > 0 && !DEMO_MODE;
